import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useI18n } from '../i18n';
import { useDocumentTitle } from './a11y';

// Shown when the sign-in context can't be loaded (e.g. the database function
// isn't reachable). Says so plainly instead of silently falling back to
// another role's screen — that silent fallback is what hid the "admin shown
// as teacher" bug. The technical message goes to the console, not the page.
// Two ways out, never a dead end: try again, or sign out.
export function ContextError({ message }: { message: string }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  useDocumentTitle(t['ctx.errorTitle']);
  console.error('my_context failed:', message);

  async function signOut() {
    await supabase.auth.signOut();
    navigate('/teacher/login');
  }

  return (
    <main className="not-found">
      <div>
        <h1>{t['ctx.errorTitle']}</h1>
        <p className="text-muted">{t['ctx.errorBody']}</p>
        <div className="form-actions centered">
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            {t['ctx.retry']}
          </button>
          <button type="button" className="btn btn-ghost" onClick={signOut}>
            {t.signOut}
          </button>
        </div>
      </div>
    </main>
  );
}
